import React from 'react'
import PropTypes from 'prop-types'
import {injectIntl} from 'react-intl'
import styled from 'styled-components'

import { AVAILABLE, UNAVAILABLE } from 'commons/js/constants'
import { Events } from 'commons/js/services/analytics'
import ParkingLegend from 'commons/js/components/ParkingLegend'
import ParkingRestrictions from 'commons/js/components/ParkingRestrictions'
import { ServiceIconMeasures, Services, PARKING_HEIGTH, PARKING_LENGTH } from 'commons/js/components/ParkingServices'
import ParkingMapCardButton from './ParkingMapCardButton'
import Distance from './Distance'
import ParkingAirportService from './ParkingAirportService'
import { isTruckParking } from '../../util/isTruckParking'
import { Flex } from '@elparking/components'

import {
    MapCard,
    ParkingMapTextBlock,
    ParkingMapNameBlock,
    ParkingAddressBlock,
    ButtonPrice,
} from './layout'

const ServicesContainer = styled(Flex)`
    margin-top:-10px;

    & > * {
        margin-top:10px;
    }
`
class ParkingMapCard extends React.PureComponent {
    static propTypes = {
        parking: PropTypes.shape({
            name: PropTypes.string,
            isAirport: PropTypes.bool,
            address: PropTypes.string,
            price: PropTypes.number,
            max_height: PropTypes.number,
            max_length: PropTypes.number,
            services: PropTypes.array,
            bookingRestriction: PropTypes.object,
            bookingAvailability: PropTypes.shape({
                price: PropTypes.number,
                availabilityStatus: PropTypes.string,
            }),
            bookingServices: PropTypes.arrayOf(PropTypes.shape({
                type: PropTypes.number,
                transferTime: PropTypes.string,
                transferTimeFrequency: PropTypes.string,
            })),
            typeString: PropTypes.string,
            longitude: PropTypes.number,
            latitude: PropTypes.number,
            media: PropTypes.shape({
                medium: PropTypes.string,
            }),
        }),
        computeDistanceTo: PropTypes.func,
        buildParkingUrl: PropTypes.func,
    }

    static defaultProps = {
        computeDistanceTo: () => 0,
        buildParkingUrl: () => '',
    }

    renderRestrictions () {
        const { parking } = this.props
        const { bookingRestriction, bookingAvailability } = parking
        const { availabilityStatus } = bookingAvailability

        if (!bookingRestriction) {
            return null
        }

        if (availabilityStatus === AVAILABLE || availabilityStatus === UNAVAILABLE) {
            return null
        }

        return <ParkingRestrictions restrictions={bookingRestriction} />
    }

    renderAirportBlock () {
        const { bookingServices } = this.props.parking

        return <ParkingAirportService bookingServices={bookingServices} />
    }

    render () {
        const { parking, computeDistanceTo, buildParkingUrl } = this.props
        const { name, address, isAirport } = parking
        const distance = computeDistanceTo(parking.latitude, parking.longitude)
        const url = buildParkingUrl(parking)

        return (
            <MapCard>
                <a rel='noopener noreferrer' href={url} target='_blank' data-event={Events.parkingSearchCardSelect}>
                    <ParkingMapTextBlock>
                        <ParkingLegend parking={parking} />
                        <ParkingMapNameBlock>{name}</ParkingMapNameBlock>
                        <ParkingAddressBlock>{address} <Distance distance={distance} /></ParkingAddressBlock>
                    </ParkingMapTextBlock>
                    <ServicesContainer alignItems='center' flexWrap='wrap' maxWidth='100%' m='0 16px' minHeight='35px'>
                        <ServiceIconMeasures
                          measure={isTruckParking(parking) ? PARKING_LENGTH : PARKING_HEIGTH}
                          value={isTruckParking(parking) ? parking.max_length : parking.max_height}
                        />
                        <Services services={parking.services} />
                    </ServicesContainer>
                    <ParkingMapTextBlock>
                        { isAirport && this.renderAirportBlock() }
                    </ParkingMapTextBlock>
                    <ParkingMapTextBlock>
                        { this.renderRestrictions() }
                    </ParkingMapTextBlock>
                    <ParkingMapCardButton parking={parking} buttonComponent={ButtonPrice} />
                </a>
            </MapCard>
        )
    }
}

export default injectIntl(ParkingMapCard)
